import axios from 'axios';

import { CSRF_TOKEN } from '@shared/config/csrf';

import { IAvailabilityUser, IUnavailability } from './types';

const WRITE_REQUEST_TIMEOUT_MS = 30_000;

const writeRequestConfig = () => ({
  timeout: WRITE_REQUEST_TIMEOUT_MS,
  headers: {
    'X-CSRF-Token': CSRF_TOKEN ?? '',
  },
});

export const fetchMoverUsers = async (): Promise<IAvailabilityUser[]> => {
  const { data } = await axios.get<IAvailabilityUser[]>('/users.json', { params: { 'roles[]': 'mover' } });
  return data;
};

export const fetchUnavailabilities = async (params: Record<string, string | number>): Promise<IUnavailability[]> => {
  const { data } = await axios.get<IUnavailability[]>('/unavailabilities.json', { params });
  return data;
};

export const createUnavailability = async (unavailability: IUnavailability): Promise<IUnavailability> => {
  const { data } = await axios.post<IUnavailability>(
    '/unavailabilities.json',
    { unavailability },
    writeRequestConfig(),
  );
  return data;
};

export const updateUnavailability = async (unavailability: IUnavailability): Promise<IUnavailability> => {
  const { data } = await axios.patch<IUnavailability>(
    `/unavailabilities/${unavailability.id}.json`,
    { unavailability },
    writeRequestConfig(),
  );
  return data;
};

export const destroyUnavailability = async (id: number): Promise<void> => {
  await axios.delete(`/unavailabilities/${id}.json`, writeRequestConfig());
};

export const errorMessageFromResponse = (error: unknown): string => {
  if (!axios.isAxiosError(error)) {
    return 'An unknown error occurred. Please contact technical support.';
  }

  if (error.response?.data?.message) {
    return String(error.response.data.message);
  }

  switch (error.response?.status) {
    case 403:
      return "Forbidden - You don't have permission to perform this action";
    case 500:
      return 'The server encountered an unexpected error. Please try again shortly.';
    case 503:
      return 'The server is undergoing maintenance. Please try again shortly.';
    default:
      return 'An unknown error occurred. Please contact technical support.';
  }
};
